<template>
  <ModalDialog
    ref="dialog"
    title="Select Inventory Bin"
    icon="fa-warehouse"
    :showFooter="true"
    :scrollable="false"
    :showSubmit="true"
    submitTitle="Select"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="form" :labelColumnSize="3">
      <ContentTitle>{{message}}</ContentTitle>

      <FormRow label="Source Inventory Bin">
        <FormInventoryBinSelect
          v-model="inventoryBinId"
          placeholder="Inventory Bin"
          :accountLocationId="accountLocationId"
          :inventoryBinIdFilter="inventoryBinIdFilter"
        />
      </FormRow>
            
    </FormGroup>
    
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import FormInventoryBinSelect from '@/modules/inventory/components/formInventoryBinSelect'

export default {
  name: 'StationSelectInventoryBinDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
    FormInventoryBinSelect
  },
  props: {
    accountLocationId: Number,
    message: String,
    inventoryBinList: Array
  },
  data() {
    return {
      form: {},
      inventoryBinId: null
    }
  },
  created() {
  },
  mounted() {
  },
  computed: {
    inventoryBinIdFilter() {
      return (this.inventoryBinList || []).map(inventoryBin => inventoryBin.id)
    }    
  },
  methods: {
    show() {
      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.modalClosed({ inventoryBinId: this.inventoryBinId })
      this.hide()
    },    
  }
}
</script>